import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './menu-bar.css';
import pictoBloxLogo from './PictobloxLogo.svg';
import bluetoothPortConnected from './Icon_Bluetooth_Connected.svg';
import portDisconnected from './Icon_Disconnect.svg';
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import "./menu-bar.css";

class MenuBar extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this,[
            "handleOnClickConnectionMenu",
            "handleOnClickWebCamMenu"
        ])
    }
    
    componentDidMount() {
      
    }
    componentWillUnmount() {
      
    }
    
    handleOnClickConnectionMenu()
    {
        if(this.props.isPictoBloxConnected && this.props.currentSelectedBoard!= "None")
        this.props.boardConnectionHandler();
        else if(!this.props.isPictoBloxConnected)
        window.alert("PictoBlox is not connected!!");
        else if(this.props.currentSelectedBoard== "None")
        window.alert("Please select the board first from PictoBlox");
    }
    handleOnClickWebCamMenu(){
        if(!this.props.isPictoBloxConnected)
        {
            window.alert("PictoBlox is not connected!!");
            return;
        }
        if(this.props.isCameraEnabled)
        this.props.webCamConnectionHandler("disable");
        else
        this.props.webCamConnectionHandler("enable");
    }
    render() {
        return (
            <div
                className="menu-bar"
            >
                {/* Main Menu */}

                <div className="main-menu">
                    <div className="file-group">

                        {/* Logo */}

                        <div className="menu-bar-item">
                            <img
                                alt="Scratch"
                                className={"scratch-logo"}
                                draggable={false}
                                src={pictoBloxLogo}
                            />
                        </div>
                        <div className="header-main">
                                <h3 >Chromebook Link</h3>
                                <p>Beta</p> 
                        </div>
                            <div className="border-dash"></div>
                        <div 
                        className="menu-bar-item hoverable"
                        onMouseUp={this.handleOnClickWebCamMenu}
                        >
                            {
                                this.props.isCameraEnabled?(<div className="edit-menu">Disable Webcam</div>):(<div className="edit-menu">Enable Webcam</div>)
                            }
                        </div>
                        <div
                            className="menu-bar-item hoverable"
                            onMouseUp={this.handleOnClickConnectionMenu}
                        >
                            {
                                this.props.isBluetoothPortConnected?(<div className="edit-menu">Disconnect</div>):(<div className="edit-menu">Connect</div>)
                            }
                        </div>
                        <div
                        className="menu-bar-item"
                        onMouseUp={this.handleOnClickConnectionMenu}
                        >
                            {
                            (this.props.isBluetoothPortConnected ?
                                        <img
                                            className={"connect-logo"}
                                            draggable={false}
                                            src={bluetoothPortConnected}
                                        />
                                        :
                                        <img
                                            // alt="Scratch"
                                            className={"connect-logo"}
                                            draggable={false}
                                            src={portDisconnected}
                                        />
                                    )
                            }
                        </div>


                    </div>
                </div>
            </div >
        );
    }
}

MenuBar.propTypes = {
    
};

MenuBar.defaultProps = {
    logo: pictoBloxLogo,
};

const mapStateToProps = state =>{
    return {
        isBluetoothPortConnected: state.menuBarReducer.isBoardConnected,
        isCameraEnabled: state.menuBarReducer.isCameraEnabled,
        isPictoBloxConnected: state.codingAreaReducer.isConnectedWithPictoBlox,
        currentSelectedBoard: state.codingAreaReducer.currentSelectedBoard
    }
}

export default connect(mapStateToProps)(MenuBar);
